export default __webpack_public_path__ + "static/media/MasaiOneCourseImage1.61e16763.svg";